export default __webpack_public_path__ + "static/media/info.2b44c1b3.png";